"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var registry = {};
var pendings = {};
var resolved = {};
var chunks = {};
var AppRegistry = /** @class */ (function () {
    function AppRegistry() {
    }
    AppRegistry.register = function (name, loader, fn) {
        registry[name] =
            typeof loader === 'function'
                ? loader
                : function () { return AppRegistry.import(Array.prototype.concat(loader)).then(fn || (function () { return null; })); };
    };
    AppRegistry.set = function (name, value) {
        pendings[name] = Promise.resolve(value);
        resolved[name] = value;
    };
    AppRegistry.import = function (moduleNames) {
        return this.chunksInstallation.then(function () {
            return Promise.all(Array.prototype.concat(moduleNames).map(function (name) {
                if (!pendings[name]) {
                    var moduleFn = registry[name];
                    if (!moduleFn) {
                        throw new Error("The module \"" + name + "\" is not registered.");
                    }
                    pendings[name] = Promise.resolve(moduleFn()).then(function (value) { return (resolved[name] = value); });
                }
                return pendings[name];
            }));
        });
    };
    AppRegistry.require = function (name) {
        return resolved[name];
    };
    AppRegistry.install = function (srcs) {
        var _this = this;
        this.chunksInstallation = this.chunksInstallation.then(function () {
            return Promise.all(Array.prototype.concat(srcs).map(function (src) { return _this.installChunk(src); }));
        });
        return this.chunksInstallation;
    };
    AppRegistry.installChunk = function (scriptSrc) {
        if (chunks[scriptSrc]) {
            return chunks[scriptSrc];
        }
        var chunkInstallation = new Promise(function (resolve) {
            var timeout = setTimeout(function () {
                console.log(new Error('Script injection timeout'));
                resolve();
            }, 12000);
            var script = document.createElement('script');
            script.src = scriptSrc;
            script.onload = function () {
                clearTimeout(timeout);
                resolve();
            };
            script.onerror = function () {
                console.log(new Error('Chunk failed to load: ' + scriptSrc));
                clearTimeout(timeout);
                resolve();
            };
            document.head.appendChild(script);
        });
        return (chunks[scriptSrc] = chunkInstallation);
    };
    AppRegistry.chunksInstallation = Promise.resolve();
    return AppRegistry;
}());
exports.AppRegistry = AppRegistry;
//# sourceMappingURL=index.js.map